import { ErrorBoundary } from '~/modules/errors/components/ErrorBoundary';
import { ErrorContent } from '~/modules/errors/components/ErrorContent';
import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';

import { Layout } from './components/Layout';
import { Router } from './router';

export function App() {
  const [isDdexConsoleEnabled] = useFeatureFlags([
    FEATURE_FLAGS.ContainerDdexConsole,
  ]);

  return (
    <Layout>
      <ErrorBoundary key="ddex-console">
        {isDdexConsoleEnabled ? <Router /> : <ErrorContent type="notFound" />}
      </ErrorBoundary>
    </Layout>
  );
}

App.displayName = 'DDEXConsoleApp';
